<template>
  <div class="listmain ">
      <h1 class="firTitle">实现相关协议</h1>
    <p>头文件 OrionSDKDataSource.h、OrionSDKDelegate.h、OrionSDKUIConfigDataSource.h。</p>
      <h3 class="sedTitle">OrionSDKDataSource</h3>

          <highlight-code lang="javascript">
             <span>
              #pragma mark -
#pragma mark OrionSDKDataSource

/**
 * @brief   提供当前控制器用于 Push 新界面，如只用API的话，这个可不实现。
 */
- (UIViewController *)currentNavigationController {
    UINavigationController *navigationController;
    UIViewController *rootVC = [UIApplication sharedApplication].delegate.window.rootViewController;
    if ([rootVC isKindOfClass:[UINavigationController class]]) {
        navigationController = ((UINavigationController*)rootVC);
        rootVC = ((UINavigationController*)rootVC).topViewController;
    }
    if (rootVC.presentedViewController) {
        if ([rootVC.presentedViewController isKindOfClass:[UITabBarController class]]) {
            UIViewController *temp = [(UITabBarController*)rootVC.presentedViewController selectedViewController];
            if ([temp isKindOfClass:[UINavigationController class]]) {
                navigationController = ((UINavigationController*)temp);
            }
        }
        else if ([rootVC.presentedViewController isKindOfClass:[UINavigationController class]]) {
            UINavigationController *temp = (UINavigationController *)rootVC.presentedViewController;
            return temp;
        }
    }
    return navigationController;
}

/**
 * @brief   app 是否登录
 * @return  Bool
 */
- (BOOL)isAppLogin {
    return [OVSUserModel sharedInstance].isLogin;
}

/**
 *  @brief  提供当前定位信息（缓存的即可）
 *  @return 当前定位信息
 *   longitude   经度
 *   latitude    纬度
 */

- (nonnull NSString *)apnsToken {
    // 推送需要使用到 devicetoken，请自行设置
    return @"xxxxxxxxxxxxxxxxx";
}

/**
 *  @brief  提供当前定位信息（缓存的即可）
 *  @return 当前定位信息
 *   longitude   经度
 *   latitude    纬度
 */
- (nonnull NSDictionary *)locationInfo {
    return @{
             @"longitude": @"12.8",
             @"latitude": @"44.23"
             };
}


/**
 * @brief   提供当前设备ID
 * @return  设备ID，便于后期做运营需求及统计
 */

- (nonnull NSString *)deviceID {
    // demo 演示 UUID ,接入需要真实UUID
    return @"C0975C13-03CE-4149-8B04-4F94B729E497";
}

/**
 * @brief   提供宿主当前 app 版本号
 * @return  设备ID，便于后期做运营需求及统计
 */

- (nonnull NSString *)appVersion {
    return [[NSBundle mainBundle] objectForInfoDictionaryKey:@"CFBundleShortVersionString"];
}

/**
 * @brief   提供当前设备信息
 *  speakerDeviceId  音响设备真实 id
 *  speakerId        音响设备（服务器生成的） id
 *  imei             设备imei
 *  model            设备型号
 *  name             设备名称
 *  osVersion        设备系统版本
 *  sn               设备序列号
 *  ssid             设备配网WiFi名称
 *  version          设备版本
 * @return  当前设备信息用于后续交互
 */

- (nonnull NSDictionary *)currentSpeakerDeviceInfo {
    if ([OVSUserModel sharedInstance].currentDivece) {
        return @{
                 @"speakerDeviceId": [OVSUserModel sharedInstance].currentDivece.controlSpeakerDeviceId?:@"",
                 @"speakerId": [OVSUserModel sharedInstance].currentDivece.controlSpeakerId?:@"",
                 @"imei": [OVSUserModel sharedInstance].currentDivece.imei?:@"",
                 @"model": [OVSUserModel sharedInstance].currentDivece.model?:@"",
                 @"name": [OVSUserModel sharedInstance].currentDivece.name?:@"",
                 @"osVersion": [OVSUserModel sharedInstance].currentDivece.osVersion?:@"",
                 @"sn": [OVSUserModel sharedInstance].currentDivece.sn?:@"",
                 @"ssid": [OVSUserModel sharedInstance].currentDivece.ssid?:@"",
                 @"version": [OVSUserModel sharedInstance].currentDivece.version?:@""
                 };
    }
    return @{ };
}


             </span>
    </highlight-code>
      <h3 class="sedTitle">OrionSDKDelegate</h3>
      <highlight-code lang="javascript">
         <span>
             #pragma mark -
#pragma mark OrionSDKDelegate

/**
 *  @brief  可能会触发配网流程 如 ：音箱状态离线提示配网。
 */
- (void)configNetwork {
    // 处理你的配网流程
}

/**
 *  @brief  token 过期
 */
- (void)tokenExpired {
    // 处理你的登录流程
    [[OrionSDK shared] logout];
    [OVSUserModel sharedInstance].isLogin = NO;
    UIStoryboard *storyBoard = [UIStoryboard storyboardWithName:@"Main" bundle:nil];
    UIViewController *login = [storyBoard instantiateViewControllerWithIdentifier:@"verification"];
    OVSBaseNavigationController *navigationController = [[OVSBaseNavigationController alloc] initWithRootViewController:login];
    [UIApplication sharedApplication].delegate.window.rootViewController = navigationController;
}

/**
 *  @brief  处理SDK不能处理的URL，需要app实现此协议，进行跳转或提示用户无法跳转。
 *  @see `- (BOOL)openURL:(NSURL *)url`
 */
- (BOOL)openURLInApp:(NSURL *)url {
    return NO;
}

         </span>
      </highlight-code>
      <h3 class="sedTitle">OrionSDKUIConfigDataSource</h3>
      <highlight-code lang="javascript">
         <span>
             #pragma mark -
#pragma mark 信息流资源配置

/**
 * @brief   信息流默认头像,不实现将使用默认样式
 * @return  UIImage
 */

- (nonnull UIImage *)defaultAvatarOfChat {
    return [UIImage imageNamed:@"avatar"];
}

/**
 * @brief   信息流纠错字体颜色
 * @return  UIColor
 */
- (nonnull UIColor *)errorCorrectFontColor {
    return [UIColor colorWithRed:0.329 green:0.396 blue:0.616 alpha:1.00];
}

/**
 * @brief   信息流响应气泡颜色,不实现将使用默认样式
 * @return  UIColor
 */

- (nonnull UIColor *)responseBubbleColorOfChat {
    return [UIColor colorWithRed:0.929 green:0.925 blue:0.949 alpha:0.6];
}

/**
 * @brief   信息流发送气泡,不实现将使用默认样式
 * @return  UIColor
 */

- (nonnull UIColor *)sendBubbleColorOfChat {
    return [UIColor colorWithRed:0.082 green:0.722 blue:0.980 alpha:0.5];
}

/**
 * @brief   是否显示纠错引导
 * @return  BOOL
 */

- (BOOL)errorCorrectGuide {
    return NO;
}

#pragma mark -
#pragma mark 闹钟资源配置


/**
 * @brief   闹钟教育图片,不实现将采用默认样式
 * @return  UIImage
 */
- (nonnull UIImage *)educationImageOfAlarm {
    return [UIImage imageNamed:@"pic_alarm_education"];
}

/**
 * @brief   闹钟导航栏右侧添加闹钟按钮
 * @return  UIImage
 */
- (nonnull UIImage *)addAlarmImage {
    return [UIImage imageNamed:@"ic_add_n"];
}

#pragma mark -
#pragma mark 收藏资源配置

/**
 * @brief   收藏里歌曲Cell选择按钮图片，不实现将采用默认样式
 * @return  UIImage
 */
- (nonnull UIImage *)choiceButtonImage {
    return [UIImage imageNamed:@"ic_list_choise_c"];
}

#pragma mark -
#pragma mark AI 口令资源配置

/**
 * @brief   AI 口令设置编辑口令输入框选中图片
 * @return  UIImage
 */
- (nonnull UIImage *)inputFieldImage {
    return [UIImage imageNamed:@"bg_ai_word"];
}

#pragma mark -
#pragma mark 通用资源配置

/**
 * @brief   主题颜色 如：提示语等；
 * @return  UIColor
 */
- (nonnull UIColor *)themeColor {
    return [UIColor colorWithRed:0.082 green:0.722 blue:0.980 alpha:0.5];
}

/**
 * @brief   关闭按钮 图片，如：修改手机号成功页面关闭按钮图片；
 * @return  UIImage
 */
- (nonnull UIImage *)closeBarButtonItemImage {
    return [UIImage imageNamed:@"ic_close_n"];
}

/**
 * @brief   成功按钮 图片 ，如：修改手机号成功按钮图片；
 * @return  UIImage
 */
- (nonnull UIImage *)successButtonImage {
    return [UIImage imageNamed:@"pic_success"];
}

/**
 * @brief   全局音箱名称，默认为“小雅”
 * @return  NSString
 */
- (nonnull NSString *)globalSpeakerName {
    return @"小豹";
}

/**
 * @brief   通用按钮Normal状态背景图片 如：修改手机号、快递查询、QQ 音乐登录、AI 口令按钮
 * @return  UIImage
 */
- (nonnull UIImage *)buttonImageForStateNormal {
    return [UIImage imageNamed:@"buttonbackground"];
}

/**
 * @brief   通用按钮Normal状态背景图片 如：修改手机号、快递查询、QQ 音乐登录、AI 口令按钮；
 * @return  UIImage
 */
- (nonnull UIImage *)buttonImageForStateHighlighted {
    return [UIImage imageNamed:@"buttonbackground"];
}

/**
 * @brief   通用无数据icon,不实现将采用默认样式
 * @return  UIImage
 */
- (nonnull UIImage *)defaultLoadEmptyDataIcon {
    return [UIImage imageNamed:@"img_no_content"];
}

/**
 * @brief   通用网络错误icon,不实现将采用默认样式
 * @return  UIImage
 */
- (nonnull UIImage *)defaultLoadErrorViewIcon {
    return [UIImage imageNamed:@"img_no_network"];
}

/**
 * @brief   通用单选按钮 Normal icon,不实现将采用默认样式
 * @return  UIImage
 */
- (nonnull UIImage *)singleSelectionButtonForStateNormal {
    return [UIImage imageNamed:@"ic_trip_mode_unselected"];
}

/**
 * @brief   通用单选按钮 Highlighted icon,不实现将采用默认样式
 * @return  UIImage
 */
- (nonnull UIImage *)singleSelectionButtonForStateHighlighted {
    return [UIImage imageNamed:@"ic_trip_mode_selected"];
}


         </span>

      </highlight-code>

     <p></p>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/Agreement.vue